
export default function NotFound() {
    return (
        <div><br/><br/><br/><h1 align="center">404 Not Found</h1></div>
    )
}